import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import '../../pages/markets/pages/stocks-in-indices-external/stocks-in-indices-external.m.css';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import StocksInIndicesExternalWidget from '../../pages/markets/component/stock-in-indices-external-widget';
import MarketNewsExternalWidget from '../../pages/markets/component/market-news-external-widget';

const StockIndicesFull = () => {
  const [news, setNews] = useState({});
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);
  const [marketNews, setMarketNews] = useState({});

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getAllNews = async () => {
      const response = await fetch('/api/v1/collections/all-news-module');
      const dataInJson = await response.json();

      setNews(dataInJson);
    };
    getAllNews();
  }, []);

  useEffect(() => {
    const getMarketNews = async () => {
      const response = await fetch('/api/v1/collections/markets');
      const data = await response;
      const dataInJson = await data.json();
      setMarketNews(dataInJson);
    };
    getMarketNews();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div className="container">
            <StocksInIndicesExternalWidget />
          </div>
        </div>
        <div className="container">
          <div styleName="market-video-container">
            <MarketNewsExternalWidget collection={marketNews} sectionTitle={'MARKETS NEWS'} />
          </div>
        </div>
      </>
    </QueryClientProvider>
  );
};

export default StockIndicesFull;
